import { selectBalancingOutskirtUnlockLevel } from "../balancingSelectors/selectBalancingOutskirts";
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { warn } from "../utils/logging/logging";
import { selectPlayerLevel } from "./selectPlayerLevelInfo";
export var selectPierInfo = function (state) {
    warn("Pier not implemented!");
};
export var selectIsQualifiedForPier = function (state) {
    var level = selectPlayerLevel(state);
    return level >= selectBalancingOutskirtUnlockLevel(IdOutskirtBuildings.Pier);
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectPierInfo.ts
// module id = 2156
// module chunks = 3